import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function CameraIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.71478 3.54962H6.15084C5.81648 3.54962 5.50425 3.71672 5.31879 3.99492L4.87948 4.65389C4.69401 4.93209 4.38178 5.09919 4.04742 5.09919H3.03304C2.4628 5.09919 2 5.56199 2 6.13223V12.847C2 13.4173 2.4628 13.8801 3.03304 13.8801H12.3304C12.9007 13.8801 13.3635 13.4173 13.3635 12.847V7.16527"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0061 9.48954C10.0061 10.7731 8.96533 11.8139 7.68177 11.8139C6.39821 11.8139 5.35742 10.7731 5.35742 9.48954C5.35742 8.20598 6.39821 7.16519 7.68177 7.16519C8.96533 7.16519 10.0061 8.20598 10.0061 9.48954Z"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0352 2L14.2091 3.17391L13.0352 4.34783"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6261 7.16518L10.4521 5.99127L11.6261 4.81735"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4521 5.99126H13.5043C14.2822 5.99126 14.913 5.3604 14.913 4.58256V4.34778"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2079 3.17395H11.1558C10.3779 3.17395 9.74707 3.80481 9.74707 4.58265V4.81743"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>

  );
}
